exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status-switch[data-v-09a5f77a]  .el-switch__core {\n  width: 32px !important;\n  height: 16px !important;\n}\n.status-switch[data-v-09a5f77a]  .el-switch__core::after {\n  width: 12px !important;\n  height: 12px !important;\n}\n.status-switch[data-v-09a5f77a]  .el-switch.is-checked .el-switch__core::after {\n  margin-left: -13px !important;\n}\n", ""]);

// exports
